import React from 'react'

export default function FAQ () {
  return (
    <div className='page-content'>FAQ page</div>
  )
}
